<template>
<section>
    <div class="wrap">
        <div class="sort_consultant_box">
            <select v-model="zipCode">
                <option value="">지역</option>
                <option v-for="loaction in SIGUNGU_CODE"
                    :key="`sc-find-location-select-item-${loaction.id}`"
                    :value="loaction.id">
                    {{loaction.name}}
                </option>
            </select>

            <select v-model="dealerId">
                <option value="">딜러사</option>
                <option v-for="dealer in dealerItemsFilter"
                    :key="`sc-find-dealer-select-item-${dealer.id}`"
                    :value="dealer.id">
                    {{dealer.name}}
                </option>
            </select>

            <select v-model="shopId">
                <option value="">전시장</option>
                <option v-for="shop in shopItemsFilter"
                    :key="`sc-find-shop-select-item-${shop.id}`"
                    :value="shop.id">
                    {{shop.name}}
                </option>
            </select>

            
        </div>

        <ul class="consultant_find_list">
            <li
                v-for="(sc, idx) in scItems" 
                :key="`consultant-find-list-item-${idx}`"
            >
                <figure>
                    <img :src="sc.attUrl ? sc.attUrl : resource.imgSampleConsultantSquare">
                </figure>
                <figcaption>
                    <dl>
                        <dt>
                            <p>
                                <router-link :to="`scInfo/${sc.id}`">
                                    {{sc.name}} 컨설턴트
                                </router-link>
                            </p>
                            
                            <span v-if="sc.certificationYn == 'Y'">
                                <img :src="resource.imgIconCertified2">인증
                            </span>
                        </dt>
                        <dd>
                            <router-link :to="`shopInfo/${sc.shopId}`">
                                {{sc.shopName}}
                            </router-link>
                            <router-link :to="`dealerInfo/${sc.dealerId}`">
                                ({{sc.dealerName}})
                            </router-link>
                        </dd>
                        <dd>경력 {{ $_getScCareerByMonth(sc.careerMonth) }}</dd>
                    </dl>
                    <div class="social">
                        <div>
                            <span><i class="fas fa-star"></i>{{ sc.good }}</span>
                            <span><i class="fas fa-comment"></i>{{ sc.reviewCount }}</span>
                        </div>
                        <button @click="next(sc)">예약하기</button>
                    </div>
                </figcaption>
            </li>
        </ul>

    </div>
</section>
</template>

<script>
import { mapState } from 'vuex';
import { InfinityScrollMixin } from '../../mixins/InfinityScrollMixin';

export default {
    name:'ScList',
    mixins: [ InfinityScrollMixin ],
    async created() {
        this.$store.state.headerTitle = '컨설턴트 직접 찾기';
        await this.$store.dispatch('GET_DEALER_LIST')
        await this.$store.dispatch('GET_SHOP_LIST')
        await this.setScroll();
        await this.getContentList();
        this.$store.commit('SHOW_ONLOAD');
        // console.log(this.bookingWrite);
    },
    destroyed() {
        this.removeScroll();
    },
    data() {
        return {
            zipCode: '',
            dealerId: '',
            shopId: '',
        }
    },
    watch: {
        // 딜러 변경시 선택된 전시장이 해당 딜러에 속하는지 체크하나다. 
        // true => 전시장 변경 없음
        // false => 전시장 빈값 변경
        dealerId() {
            if(this.shopId) {
                let shop = this.shopItemsFilter.find((shopItem) => shopItem.shopId == this.shopId)
                if(!shop) this.shopId = ''; 
            }
            else {
                this.resetScroll();
            }
        },
        shopId() {
            this.resetScroll();
        },
        zipCode() {
            this.resetScroll();
        }
    },
    computed: {
        ...mapState(["resource"]),
        ...mapState({
            dealerItems: state => state.dealer.items,
            shopItems: state => state.shop.items,
            scItems : state => state.sc.items,

            totalCount: state => state.sc.totalCount,
            bookingWrite: state => state.booking.itemWrite,
            SIGUNGU_CODE: state => state.codeDictionary.SIGUNGU_CODE,
        }),
        dealerItemsFilter() {
            return this.dealerItems.filter( (dealer) => (this.brandId) ? (dealer.brandId == this.brandId) : true );
        },
        shopItemsFilter() {
            return this.shopItems.filter( (shop) =>
                (this.dealerId) ? (shop.dealerId == this.dealerId)
                                : (shop.brandId == this.brandId)
            );
        },
        brandId() {
            return this.bookingWrite.brandId;
        },
        bookingId(){
            return Number(this.$route.params.bookingId);
        },
        routerPath() {
            let path = '/booking/inputVehicle';
            return (this.bookingId) ? `${path}/${this.bookingId}`: path;
        },
    },
    methods: {
        next(sc) {
            this.bookingWrite.scId = sc.id;
            this.bookingWrite.scName = sc.name;
            this.bookingWrite.scUrl = sc.attUrl;
            this.bookingWrite.scShopName = sc.shopName;
            this.bookingWrite.scDealerName = sc.dealerName;
            this.$router.push(this.routerPath);
        },

        resetScroll() {
            this.$store.commit('CLEAR_SC_LIST');
            this.changeSearchOption();
        },

        getContentList() {
            if(this.scItems.length < this.totalCount || this.page == 0) {
                this.$store.dispatch(
                    'GET_SC_LIST_PAGE',
                    {
                        zipCode: this.zipCode,
                        brandId: this.brandId,
                        dealerId: this.dealerId,
                        shopId: this.shopId,
                        orderby: "name",
                        page: this.page++,
                        size: this.limit
                    }
                )
                .then(() => {
                    this.scrollPause = false;
                });
            }
            else {
                this.doneFlag = true;
            }
        },
    },
}
</script>

<style scoped>
</style>